import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { useDisableChat, useEnableChat } from "../api/toggle-chat";

export function ChatToggle() {
  const isChatEnabled = useVidyoStore((state) => state.chat.isChatEnabled);
  const sessionId = useVidyoStore((state) => state.sessionId);

  const { mutateAsync: enableChat, isPending: isEnablingChat } =
    useEnableChat();

  const { mutateAsync: disableChat, isPending: isDisablingChat } =
    useDisableChat();

  const handleToggleChat = async () => {
    if (isChatEnabled) {
      await disableChat({ sessionId: sessionId });
    } else {
      await enableChat({ sessionId: sessionId });
    }
  };

  const isLoading = isEnablingChat || isDisablingChat;

  return (
    <div className="flex items-center gap-2">
      <Switch
        id="enable-chat"
        checked={isChatEnabled}
        onCheckedChange={handleToggleChat}
        disabled={isLoading}
      />
      <Label htmlFor="enable-chat">Enable chat</Label>
    </div>
  );
}
